<template>
  
  <div v-if="items.length > 0" class="item-list" :class="{'demo': getLayout == 'simple' || getLayout == 'album', 'full-height': extendList == true, 'edit-item-list': $route.name == 'Items'}">
    <!-- LIST -->
    <div >
      <div
        class="list-item-body"
        :class="{ 'item-ischosen': checkIfInBuild(item, getBuild) == true && getLayout !== 'simple' }"
        @click="setChosen(item)"
        v-for="(item) in items"
        :key="'A' + item.id">
        <div style="margin-bottom: 5px;" class="list-item-main">
          <div style="position: relative; display: flex; ">
            <div 
              @click="open(item), $route.name !== 'Items' ? $parent.popup(item):''"
              class="img-list shadow"
              style="cursor: pointer"
              :style="[
              { backgroundImage: item.mainImg ? 'url(' + item.mainImg + ')' : 'url(' + JSON.parse(item.imgUrl)[0] + ')' }
                ]">
              <!-- Enlarge icon -->
              <span class="icon enlarge" @click="enlarge(item)">
              <img alt="expand" :style="[getLayout !== 'advanced' ? {'margin-left': '2px' }:'']" src="../../assets/img/enlarge.png"/></span>
            </div>
            <div class="info-container">
              <div class="info-list">
                <li @click=" open(item), $parent.popup(item)" class="item title">
                  <div :class="{incompatible: checkPartCompat({compatTable: getCompatLib, type: item.type, asin: item.asin}) == false}" class="list-title">
                    <span v-if="item.type!=='cpu'">{{item.brand}} </span>
                    {{ item.model }} 
                    <span style="color: #9198aa;font-size: 16px;" class="icon icon-signal" v-if="item.type =='motherboard' && item.specs && item.specs.WiFi == 'Yes'"></span> 
                    <!-- <span style="float: right; position: absolute; right: 0px; margin-right: 9.5%;"  v-if="mode=='edit_delete'">            
                      {{ item.asin }}
                    </span> -->
                    <!-- <a target="_blank" :href="item.amzn_link" v-if="item.amzn_link && item.amzn_link !== 'https://amazon.com/'">
                     Link
                    </a> -->
                  </div>
                </li>
                <li v-if="getLayout == 'simple'" class="item item-desc">
                  {{ item.description.substr(0, 73) }}
                </li>
                <div class="tips" style="margin-top: 0px;">
                  <div 
                    :class="{incompatible: compat.compatible == false, compatible: compat.compatible == true}"
                    class="tip " 
                    :style="[getListBullets(item, 5).length > 4 
                      ? {maxWidth: '16%'} 
                      : getListBullets(item, 5).length > 3 
                      ? {maxWidth: '19%'} 
                      : {maxWidth: '23%'}]" 
                      style="display: inline-block;"  
                      v-for="(compat, index) in getListBullets(item, 5)" 
                      :key="index">
                    <span class="small-bullet key">{{compat.option}}</span>
                    <span style="min-width: 70px; display: inline-block; position: inherit;text-align: center; text-transform: uppercase; font-size: 16px;" class="small-bullet value">
                      {{digitSpecList[compat.option] ? compat.option.includes('Frequency') ? parseFloat(compat.value).toFixed(2) + ' GHz' :  parseInt(compat.value) + ' ' + digitSpecList[compat.option] : compat.value}}
                    </span>
                  </div>
                </div>
              </div>
              <!-- BUTTONS -->
              <div style="vertical-align: top;" class="list-buttons">
                <div class="price">
                  <li style=" text-align: right; font-weight: 400;list-style: none;">
                    <div style="display: inline-block; color: #9198aa; opacity: 1; margin-right: -3px;font-size: 15px;margin-top: 1px; vertical-align: top;">$</div> 
                    {{ parseInt(item.amzn_price)}} 
                    <div style="display: inline-block; font-size: 10px; vertical-align: top; margin-top: 3px; margin-left: -3px;font-size: 15px;margin-top: 3px;">{{cents(parseFloat(item.amzn_price))}}</div>                
                  </li>
                </div>
                <!-- ADMIN Delete button -->
                <div style="text-align: right" v-if="mode=='edit_delete'">
                    <span
                      @click="updatePart(item)"
                      class="icon icon-edit gc-button smaller-btn"
                      style="margin-top: 2px; padding-top: 3px; "
                    ></span>
                    <span
                      @click="deletePartLocal({type: item.type, id: item.id, model: item.model})"
                      class="icon icon-circle-with-cross gc-button"
                      style="padding-top: 3px; "
                    ></span>
                </div>
                <div v-if="(typeof(ifAdded(item)) == 'object' && ifAdded(item)[item.id]) && (item.type == 'ram' || item.type == 'storage' || item.type == 'gpu' || item.type == 'graphics')"    >
                      <button v-if="(typeof(ifAdded(item)) == 'object' && ifAdded(item)[item.id])"  @click="rmFromBuild({item: item, id: item.id}), rmFromMenu({item: item, id: item.id}), getPrice()" style="width: 35% !important;" class="gc-button btn smaller-btn">
                        <span style="padding-left: 0px !important; float: none; font-size: 18px;" class="icon icon-minus "></span>
                      </button>


                      <!-- NUMBER -->
                      <!-- If ram -->
                      <div v-if="allMenuOptions && allMenuOptions.motherboard.item.contents && item.type == 'ram'"  class="call">{{getCompatibility({item: item, withType: 'motherboard', option: 'ram_slots'})}}</div>
                      <div v-if="item.type == 'ram'" :class="{
                          incompatible: checkCompatTable('motherboard', 'ram_slots', allMenuOptions, item, getCompatTable) == false,
                          compatible:   checkCompatTable('motherboard', 'ram_slots', allMenuOptions, item, getCompatTable) == true
                          }" style="display: inline-block; width: 28%;  text-align: center;">
                        <span v-if="(typeof(ifAdded(item)) == 'object' && ifAdded(item)[item.id])" style="vertical-align: -webkit-baseline-middle; padding: 2px;" class="">
                            <span class="number" style="padding-left: 0px !important; float: none; font-size: 16px;"><span>{{getItemValue({item: allMenuOptions.ram.item.contents, field: 'slots'})}}</span></span>
                        </span>
                        <!-- Tooltip -->
                        <div style="margin-left: -75px; margin-top: 20px !important;" v-if="item.type == 'ram' && allMenuOptions.motherboard.item.contents" class="tooltip" :class="{show: getTooltips.includes('max_slots@'+item.id)}">
                            <span style="font-size: 14px; color: #b2b3b4">
                              <span style="white-space: nowrap">Empty RAM Slots</span> 
                              <div :style="{fontWeight: 'bold', color: '#1997c6', display: 'inline-block',  minWidth: '200px;'}">
                                <span style="margin-left: 5px;">{{hasEmptySlots(item, getBuild, true)}}</span>
                                  <!-- <span style=" color: #9198aa !important"> / {{allMenuOptions.motherboard.item.contents.compat.M_2_Slot}}</span> -->
                              </div>
                            </span>
                        </div>
                      </div>
                      <!-- If gpu -->
                      <div v-if="allMenuOptions && allMenuOptions.motherboard.item.contents && (item.type == 'gpu' || item.type == 'graphics')"  class="call">{{getCompatibility({item: item, withType: 'motherboard', option: 'pci_e_x16'})}}</div>
                      <div v-if="item.type == 'gpu' || item.type == 'graphics'" :class="{
                          incompatible: checkCompatTable('motherboard', 'pci_e_x16', allMenuOptions, item, getCompatTable) == false,
                          compatible:   checkCompatTable('motherboard', 'pci_e_x16', allMenuOptions, item, getCompatTable) == true
                          }" style="display: inline-block; width: 28%;  text-align: center;">
                        <span v-if="(typeof(ifAdded(item)) == 'object' && ifAdded(item)[item.id])" style="vertical-align: -webkit-baseline-middle; padding: 2px;" class="">
                            <span class="number" style="padding-left: 0px !important; float: none; font-size: 16px;">
                              <span v-if="allMenuOptions.graphics.item.contents && allMenuOptions.graphics.item.contents.length >0">{{countGpus(getBuild, item.id)}}</span><span v-else>0</span>
                            </span>
                        </span>
                        <!-- Tooltip -->
                        <div style="margin-left: -75px; margin-top: 20px !important;" v-if="(item.type == 'gpu'|| item.type == 'graphics') && allMenuOptions.motherboard.item.contents" class="tooltip" :class="{show: getTooltips.includes('max_slots@'+item.id)}">
                            <span style="font-size: 14px; color: #b2b3b4">
                              <span style="white-space: nowrap">Empty PCI-Ex16 Slots</span> 
                              <div :style="{fontWeight: 'bold', color: '#1997c6', display: 'inline-block',  minWidth: '200px;'}">
                                {{hasEmptySlots(item, getBuild, true)}}
                                  <!-- <span style=" color: #9198aa !important"> / {{allMenuOptions.motherboard.item.contents.compat.M_2_Slot}}</span> -->
                              </div>
                            </span>
                        </div>
                      </div>
                    
                      <!-- If sata storage -->
                      <div v-if="allMenuOptions && allMenuOptions.motherboard.item.contents && (item.type == 'storage') && item.compat.size.toLowerCase() !== 'm.2'"  class="call">{{getCompatibility({item: item, withType: 'motherboard', option: 'sata_slots'})}}</div>
                      <div v-if="item.type == 'storage' && item.compat.size.toLowerCase() !== 'm.2'" :class="{
                          incompatible: checkCompatTable('motherboard', 'sata_slots', allMenuOptions, item, getCompatTable) == false,
                          compatible:   checkCompatTable('motherboard', 'sata_slots', allMenuOptions, item, getCompatTable) == true
                          }" style="display: inline-block; width: 28%;  text-align: center;">
                        <span v-if="(typeof(ifAdded(item)) == 'object' && ifAdded(item)[item.id])" style="vertical-align: -webkit-baseline-middle; padding: 2px;" class="">
                            <span class="number" style="padding-left: 0px !important; float: none; font-size: 16px;">
                              <span v-if="allMenuOptions.storage.item.contents && allMenuOptions.storage.item.contents.length >0">{{countStorage(getBuild, 'count', item.id)}}</span><span v-else>0</span>
                              <!-- <span style="position: absolute;white-space:nowrap;bottom:42px;right:0px;font-size: 13px;  color: #434857" v-if="allMenuOptions.motherboard.item.contents">Slots available: <span :style="[hasEmptySlots(item, getBuild, true) >0 ? {color: '#1997c6'}:'']">{{hasEmptySlots(item, getBuild, true)}}</span></span>                       -->
                            </span>
                        </span>
                        <!-- Tooltip -->
                        <div v-if="item.type == 'storage' && allMenuOptions.motherboard.item.contents && item.compat.size.toLowerCase() !== 'm.2'" class="tooltip" :class="{show: getTooltips.includes('max_slots@'+item.id)}">
                            <span style="font-size: 14px; color: #b2b3b4">
                              Empty Sata Slots 
                              <div :style="{fontWeight: 'bold', color: '#1997c6', display: 'inline-block',  minWidth: '200px;'}">
                                {{hasEmptySlots(item, getBuild, true)}}
                                  <!-- <span style=" color: #9198aa !important"> / {{allMenuOptions.motherboard.item.contents.compat.M_2_Slot}}</span> -->
                              </div>
                            </span>
                        </div>
                      </div>

                      <!-- If m.2 storage -->
                      <div v-if="allMenuOptions && allMenuOptions.motherboard.item.contents && (item.type == 'storage') && item.compat.size.toLowerCase() == 'm.2'"  class="call">{{getCompatibility({item: item, withType: 'motherboard', option: 'm.2_slots'})}}</div>
                      <div v-if="item.type == 'storage' && item.compat.size.toLowerCase() == 'm.2'" :class="{
                          incompatible: checkCompatTable('motherboard', 'm.2_slots', allMenuOptions, item, getCompatTable) == false,
                          compatible:   checkCompatTable('motherboard', 'm.2_slots', allMenuOptions, item, getCompatTable) == true
                          }" style="display: inline-block; width: 28%;  text-align: center;">
                        <span v-if="(typeof(ifAdded(item)) == 'object' && ifAdded(item)[item.id])" style="vertical-align: -webkit-baseline-middle; padding: 2px;" class="">
                            <span class="number"  style="padding-left: 0px !important; float: none; font-size: 16px;">
                              <span style="color: #cfd2da" v-if="allMenuOptions.storage.item.contents && allMenuOptions.storage.item.contents.length >0">{{countStorage(getBuild, 'count', item.id)}}</span><span style="color: #cfd2da" v-else>0</span>
                            </span>
                        </span>
                        <!-- Tooltip -->
                        <div v-if="item.type == 'storage' && allMenuOptions.motherboard.item.contents && item.compat.size.toLowerCase() == 'm.2'" class="tooltip" :class="{show: getTooltips.includes('max_slots@'+item.id)}">
                            <span style="font-size: 14px; color: #b2b3b4">
                              Empty M.2 Slots 
                              <div :style="{fontWeight: 'bold', color: '#1997c6', display: 'inline-block',  minWidth: '200px;'}">
                                {{hasEmptySlots(item, getBuild, true)}}
                                  <!-- <span style=" color: #9198aa !important"> / {{allMenuOptions.motherboard.item.contents.compat.M_2_Slot}}</span> -->
                              </div>
                            </span>
                        </div>
                      </div>
                      <!-- Buttons -->
                      <div style="display: inline-block; width: 35% !important; margin-left: 1px;  float: right; " @mouseover="showTooltip('max_slots@'+item.id) " @mouseleave="hideTooltip('max_slots@'+item.id)">
                        <button
                          v-if="(typeof(ifAdded(item)) == 'object' && ifAdded(item)[item.id]) "  
                          @click="addToBuild(item), addToMenu(item), getPrice()" 
                          :disabled="hasEmptySlots(item, getBuild) == false"
                          style=" width: 100% !important" 
                          class="gc-button btn smaller-btn">
                            <span style="padding-left: 0px !important; float: none; font-size: 18px;" class="icon icon-plus"></span>
                        </button>
                      </div>
                  </div>
                <!-- Add to build button -->
                <div v-else>
                  <div @mouseover="ifAdded(item) ? hover(item.id, true) : ''" @mouseleave="ifAdded(item) ? hover(item.id, false): ''" 
                    v-if="mode!=='edit_delete' && hasEmptySlots(item, getBuild) == true" class="list-icon check-btn add-to-build-btn" :class="{ checked: ifAdded(item) }">
                    <span
                      v-if="addButtonHovered !== item.id"
                      v-on:click="addToBuild(item), addToMenu(item), setChosen(item), getPrice()"
                      class="icon icon-check gc-button smaller-btn"
                      style="padding-top: 3px; "
                    ></span>
                    <span
                      v-if="ifAdded(item) && addButtonHovered == item.id"
                      v-on:click="unset(item), getPrice(), hover(item.id, false)"
                      class="icon icon-circle-with-cross gc-button smaller-btn"
                      style="padding-top: 3px; "
                    ></span>
                  </div>
                  <!-- DISABLED CHECK BUTTON -->
                  <div v-if="mode!=='edit_delete' && hasEmptySlots(item, getBuild) == false" class="list-icon check-btn add-to-build-btn" :class="{ checked: ifAdded(item) }">
                    <span
                      v-if="addButtonHovered !== item.id"
                      class="icon icon-check gc-button smaller-btn disabled"
                      style="padding-top: 3px; "
                    ></span>
                  </div>
                </div>
                <!-- Add to compare button -->
                <div style="margin-top: 1px; padding-top: 3px; " v-if="mode!=='edit_delete'" class="icon list-icon add-to-compare-btn"
                  :class="{'inCompareList-hide-add-btn': checkIfInCompareList(item) == true}">
                  <!-- <span v-on:click="addCompareItem(item)" class="icon icon-add-to-list gc-button"></span> -->
                  <a :href="item.amzn_link" target="_blank" class="icon icon-shopping-cart gc-button"></a>
                </div>
                <!-- Delete from compare button -->
                <div style="padding-top: 3px; " class="icon list-icon delete-from-compare-btn">
                  <span
                    style="margin-top: 6px;"
                    v-on:click="removeFromCompare(item)"
                    :class="{ inCompareList: checkIfInCompareList(item) == true }"
                    class="icon icon-minus icon-minus-hidden gc-button"
                  ></span>
                </div>
              </div>
            </div>
          </div>
          <div class="tips-mob" style="margin-top: 0px;">
            <div 
              :class="{incompatible: compat.compatible == false, compatible: compat.compatible == true}"
              class="tip" 
                style="display: inline-block;"  
                v-for="(compat, index) in getListBullets(item, 5)" 
                :key="index">
              <span class="small-bullet key">{{compat.option}}</span>
              <span style="min-width: 70px; display: inline-block; position: inherit;text-align: center; text-transform: uppercase;     font-size: 16px;" class="small-bullet value">{{digitSpecList[compat.option] ? parseInt(compat.value) + ' ' + digitSpecList[compat.option] : compat.value}}</span>
            </div>
          </div>
          <!-- <div class="tips-mob tips-mob-list" style="margin-top: 0px;">
            <div 
              :class="{incompatible: compat.compatible == false, compatible: compat.compatible == true}"
              class="tip" 
                style="display: inline-block;"  
                v-for="(compat, index) in getListBullets(item, 5)" 
                :key="index">
              <span class="small-bullet key">{{compat.option}}</span>
              <span style="min-width: 70px; display: inline-block; position: inherit;text-align: center; text-transform: uppercase;     font-size: 16px;" class="small-bullet value">{{digitSpecList[compat.option] ? parseInt(compat.value) + ' ' + digitSpecList[compat.option] : compat.value}}</span>
            </div>
          </div> -->
        </div>
        <!-- Benchmark (CPU && GPU ONLY) -->
        <div v-if="$route.name == 'cpu' || $route.name == 'gpu'"  class="bar1">
            <div style="max-width: 100%;" 
            :style="[
              allItemsLoaded ? {width:  getPerfWidth(item.performance, getMaxScores[item.type]) + '% !important'} : '0', 
              getPerfWidth(item.performance, getMaxScores[item.type]) < 20 ? {'background-color': '#e64759 ', border: '1px solid #e64759', 'box-shadow': 'none'} 
              : getPerfWidth(item.performance, getMaxScores[item.type]) < 40 ? {'background-color': '#e4d836 ', border: '1px solid #e4d836', 'box-shadow': 'none'} 
              : '']" 
              id="html-bar"></div>
        </div>
        <!-- <div style="vertical-align: bottom; border-radius: 6px 7px 7px 6px" v-if="$route.name == 'cpu' || $route.name == 'gpu'" class="benckmark progress flex-row-reverse" :class="{ isChosen: item.chosen && getLayout !== 'simple' }">
          <div
            class="progress-bar bg-succsess"
            role="progressbar"
            :style="{ width: allItemsLoaded? 100 - (item.performance+20) + '%' : 10}"
            aria-valiemin="0"
            style="background-color: #25272F; border-radius: 0px 6px 6px 0px;"
            aria-valuemax="100"
          >
          </div>
          <div class="performance-bar bar-shadow" :style="{ width: allItemsLoaded ? (item.performance+20) + '%' : 0}" style="text-align: left; padding-left: 5px; color: #191b20; font-weight: bold; font-size: 13px; float: left;">Estimated performance<span style="float: right; padding-right: 10px;">{{(item.performance+20).toFixed(2)}}</span></div>
        </div> -->
      </div>
    </div>
  </div>
  <div style="color: #9198AA; padding-left: 15px; margin-top: 15px; font-size: 16px;" v-else>
    No Results 
  </div>
</template>

<script>
import { mapActions }           from "vuex";
import { mapGetters }           from "vuex";
import { EventBus }             from "../../eventBus";
import {functions }             from "../../functions.js"
import store                    from '../../store'

export default {
  name: "List",
  props: ["items", "search", 'mode', 'new_var', 'layout'],
  data() {
    return {
      show:                     false,
      extendList:               false,
      addButtonHovered:         false,
      loaded:                   undefined,
      welcomedList:             {
        'Core_Frequency':       'Frequency',
        'Number_of_Cores':      'Cores',
        'Number_of_Threads':    'Threads',
        //'processor_generation': 'CPU Gen',
        'socket':               'Socket',
        // 'Integrated_Graphics':  'Int. Graphics',
        //'ram':                  'RAM_Type',
        'ram_speed':            'RAM Speed',
        // 'Max_Memory_Size':      'Max RAM',
        'RAM_Type':             'RAM_Type',
        'Capacity':             'Capacity',
        'RAM_Speed':            'RAM Speed',
        'Number_of_Sticks':     'Mem Slots',
        'Disk_Type':            'Type',
        'size':                 'Size',
        'speed':                'Write Speed',
        // 'graphics_processor':   'GPU',
        'GPU_clock_speed':      'GPU Clock',
        'memory_clock_speed':   'Mem Clock',
        'graphics_ram_capacity':'Memory',
        'memory_bus_width':     'Bus Width',
        'graphics_interface':   'Interface',
        'connections':          'Connectors',
        // 'VR':                   'VR Support',
        // 'WiFi':                 "WiFi",
        'form_factor':          "Size",
        // 'M_2_Slot':             'M.2_Slot',
        'm_2':                  'M.2',
        'compat_interface':     'Interface',
        'wattage':              'Wattage',
        'energy_rating':        'Rating',
        'tempered_glass':       'Tempered Glass',
        'color':                'Colors',
      },
      digitSpecList:            {
        Frequency:    'GHz',
        Cores:        ' ',
        Threads:      ' ',
        'GPU Clock': 'MHz',
        'Mem Clock': 'MHz',
        'Memory':    'GB',
        'Bus Width': 'Bit',
        Wattage:     'W',
        'RAM Speed': 'MHz',
        'ram_speed': 'MHz',
        'Ram_Speed': 'MHz',
        'Speed':     'MB/s',
      },
      benchMark:                '0',
      play:                     '',
      confirmDelete:            false,
      showConfirm:              false,
      model:                    '',      
    };
  },
  methods: {
    ...mapActions([
      "fetchItems",
      "showTooltip",
      "hideTooltip",
      "setItem",
      "addCompareItem",
      "addToBuild",
      "addToMenu",
      "rmFromMenu",
      "rmFromBuild",
      "removeFromCompare",
      "getPrice",
      "deletePart",
      "setLayout",
      'setSearchFilters',
      'setItems',
      'isCompatible',
      'itemsLoaded'
    ]),
    extend(){
      this.extendList = !this.extendList
      EventBus.$emit('extendListResponse', this.extendList)
    },
    getItemValue:       ({item, field})                           => functions.getItemValue({item, field}),
    checkPartCompat:    ({compatTable, type, asin})               => functions.checkPartCompat({compatTable, type, asin}),
    createCompatTable:  (build)                                   => functions.createCompatTable(build),
    checkCompatTable:   (type, option, build, item, compatTable)  => functions.checkCompatTable(type, option, build, item, compatTable),
    cents:              (num)                                     => functions.cents(num),
    hover(id, bool){
      if(bool == true){
        this.addButtonHovered = id
      }
      else {
        this.addButtonHovered = ''
      }
    },
    getPerfWidth(perf, max){
      var itemPerf = perf
      var maxPerf = max
      var score = (itemPerf*100)/maxPerf
      return parseFloat(score).toFixed(2)
    },
    ifHover(id){
      if(this.hovered[id] == true){
        return true
      }
      else {return false}
    },
    open(item){
      if(this.$route.name !== 'Items'){
        this.$router.push(this.$route.path + '?id='+item.id).catch(()=>{})
      }
      // else {
      //   this.$router.push('editpart?type='+item.type).catch(()=>{})
      // }
    },
    scrollToTop() {
      window.scrollTo(0,0);
    },
    ifAdded(item){
      var type = ''
      if(item && item.type){
        if(item.type == "gpu"){
            type = 'graphics'
        }
        else {
            type = item.type
        }
      }
      if(this.getMenuOptions() && this.getMenuOptions()[type] && this.getMenuOptions()[type].item.contents && (type == 'storage' || type == 'ram' || type == 'graphics' || type == 'gpu')){
        var matchIds = {}
        if((typeof(this.getMenuOptions()[type].item.contents == 'object') || typeof(this.getMenuOptions()[type].item.contents == 'object')) && this.getMenuOptions()[type].item.contents.length > 0){
          for (var i = 0; i < this.getMenuOptions()[type].item.contents.length; i++){
            if (this.getMenuOptions()[type].item.contents[i].id == item.id){
              if(!matchIds[item.id]){
                matchIds[item.id] = 0
              }
              matchIds[item.id] = matchIds[item.id] +1
            }
          }
          if(Object.keys(matchIds).length > 0){
            return matchIds
          }
          else {
            return false
            }
        }
      }
      else if(this.getMenuOptions() && this.getMenuOptions()[type] && this.getMenuOptions()[type].item.contents){
        if(item.id == this.getMenuOptions()[type].item.contents.id){
          return true
        }
      }
      return false
    },
    getMenuOptions(){
      return this.allMenuOptions
    },
    getCompatibility({item, withType, option}){
        return store.dispatch('isCompatible', {item: item, withType: withType, option: option})
        .then((res) => {return res})
    },
    getListBullets(item, lim){
      var specsList = {}
      var total = 0
      var limit = lim
      if(window.innerWidth < 584){
        limit = 3
      }
      while(total <limit){
        for (var spec in item.specs){
          if(item.specs[spec] !=='N/A' && Object.keys(this.welcomedList).includes(spec)){
            if(spec == 'connections' && item.type == 'graphics'){
              
            }
            else {
              specsList[this.welcomedList[spec].split('_').join(' ')] = item.specs[spec]
              total++
            }
           
          }
        }
        for (var compat in item.compat){
          if(item.compat[compat] !=='N/A' && Object.keys(this.welcomedList).includes(compat)){
            if(compat == 'form_factor' && item.type == 'graphics'){
              
            }
            else {
              specsList[this.welcomedList[compat].split('_').join(' ')] = item.compat[compat]
              total++
            }
          
          }
        }
      }
      // console.log(specsList)
      var specsKeys = Object.keys(specsList)
      var specsArr = []
      specsKeys.map((spc, index) => {
        specsArr.push({
          option: spc,
          value: specsList[spc]
        })
// CPU
        //Socket
        if(item.type == 'cpu' && spc.toLowerCase().includes('socket')){
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            this.getCompatibility({item: item, withType: 'motherboard', option: 'socket'})
            specsArr[index].compatible = this.checkCompatTable('motherboard', 'socket', this.allMenuOptions, item, this.getCompatTable)
          }
        }
        // Ram type
        if(item.type == 'cpu' && spc.toLowerCase().includes('ram type')){
          // console.log('ram spotted')
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            this.getCompatibility({item: item, withType: 'motherboard', option: 'ram_type'})
            specsArr[index].compatible = this.checkCompatTable('motherboard', 'ram_type', this.allMenuOptions, item, this.getCompatTable)
          }
          // check ram
          if(this.allMenuOptions && this.allMenuOptions.ram.item.contents){
            this.getCompatibility({item: item, withType: 'ram', option: 'ram_type'})
            specsArr[index].compatible = this.checkCompatTable('ram', 'ram_type', this.allMenuOptions, item, this.getCompatTable)
          }
        }
        // Generation
        if(item.type == 'cpu' && spc.toLowerCase().includes('cpu gen')){
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            this.getCompatibility({item: item, withType: 'motherboard', option: 'processor_generation'})
            specsArr[index].compatible = this.checkCompatTable('motherboard', 'processor_generation', this.allMenuOptions, item, this.getCompatTable)
          }
        }
// RAM
        // Ram type
        if(item.type == 'ram' && spc.toLowerCase().includes('ram type')){
          // console.log('ram spotted')
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            this.getCompatibility({item: item, withType: 'motherboard', option: 'ram_type'})
            specsArr[index].compatible = this.checkCompatTable('motherboard', 'ram_type', this.allMenuOptions, item, this.getCompatTable)
          }
          // check cpu
          if(this.allMenuOptions && this.allMenuOptions.cpu.item.contents){
            this.getCompatibility({item: item, withType: 'cpu', option: 'ram_type'})
            specsArr[index].compatible = this.checkCompatTable('cpu', 'ram_type', this.allMenuOptions, item, this.getCompatTable)
          }
        }
        // Capacity
        if(item.type == 'ram' && spc.toLowerCase().includes('capacity')){
          // console.log('ram spotted')
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            this.getCompatibility({item: item, withType: 'motherboard', option: 'max_memory'})
            specsArr[index].compatible = this.checkCompatTable('motherboard', 'max_memory', this.allMenuOptions, item, this.getCompatTable)
          }
          // check cpu
          if(this.allMenuOptions && this.allMenuOptions.cpu.item.contents){
            this.getCompatibility({item: item, withType: 'cpu', option: 'max_memory'})
            specsArr[index].compatible = this.checkCompatTable('cpu', 'max_memory', this.allMenuOptions, item, this.getCompatTable)
          }
        }
        // Ram Speed
        if(item.type == 'ram' && spc.toLowerCase().includes('ram speed')){
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            this.getCompatibility({item: item, withType: 'motherboard', option: 'ram_speed'})
            specsArr[index].compatible = this.checkCompatTable('motherboard', 'ram_speed', this.allMenuOptions, item, this.getCompatTable)
          }
          // check cpu
          if(this.allMenuOptions && this.allMenuOptions.cpu.item.contents){
            this.getCompatibility({item: item, withType: 'cpu', option: 'ram_speed'})
            specsArr[index].compatible = this.checkCompatTable('cpu', 'ram_speed', this.allMenuOptions, item, this.getCompatTable)
          }
        }
        // Ram Slots
        if(item.type == 'ram' && spc.toLowerCase().includes('mem slots')){
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            this.getCompatibility({item: item, withType: 'motherboard', option: 'ram_slots'})
            specsArr[index].compatible = this.checkCompatTable('motherboard', 'ram_slots', this.allMenuOptions, item, this.getCompatTable)
          }
        }
//Storage
        // Interface
        if(item.type == 'storage' && spc.toLowerCase().includes('interface')){
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            this.getCompatibility({item: item, withType: 'motherboard', option: 'interface'})
            specsArr[index].compatible = this.checkCompatTable('motherboard', 'interface', this.allMenuOptions, item, this.getCompatTable)
          }
        }
        // Sata Slots
        if(item.type == 'storage' && spc.toLowerCase().includes('sata_slots')){
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            this.getCompatibility({item: item, withType: 'motherboard', option: 'sata_slots'})
            specsArr[index].compatible = this.checkCompatTable('motherboard', 'sata_slots', this.allMenuOptions, item, this.getCompatTable)
          }
        }
//Case
        // Interface
        if(item.type == 'case' && spc.toLowerCase().includes('size')){
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            this.getCompatibility({item: item, withType: 'motherboard', option: 'form_factor'})
            specsArr[index].compatible = this.checkCompatTable('motherboard', 'form_factor', this.allMenuOptions, item, this.getCompatTable)
          }
          // check psu
          if(this.allMenuOptions && this.allMenuOptions.psu.item.contents){
            this.getCompatibility({item: item, withType: 'psu', option: 'form_factor'})
            specsArr[index].compatible = this.checkCompatTable('psu', 'form_factor', this.allMenuOptions, item, this.getCompatTable)
          }
        }
//Motherboard
        // Interface
        if(item.type == 'motherboard'){
          // check cpu
          // socket
          if(this.allMenuOptions && this.allMenuOptions.cpu.item.contents && spc.toLowerCase().includes('socket')){
            this.getCompatibility({item: item, withType: 'cpu', option: 'socket'})
            specsArr[index].compatible = this.checkCompatTable('cpu', 'socket', this.allMenuOptions, item, this.getCompatTable)
          }
          // cpu gen
          if(this.allMenuOptions && this.allMenuOptions.cpu.item.contents && spc.toLowerCase().includes('cpu gen')){
            this.getCompatibility({item: item, withType: 'cpu', option: 'processor_generation'})
            specsArr[index].compatible = this.checkCompatTable('cpu', 'processor_generation', this.allMenuOptions, item, this.getCompatTable)
          }
          // ram type
          if(this.allMenuOptions && this.allMenuOptions.cpu.item.contents && spc.toLowerCase().includes('ram type')){
            this.getCompatibility({item: item, withType: 'cpu', option: 'ram_type'})
            specsArr[index].compatible = this.checkCompatTable('cpu', 'ram_type', this.allMenuOptions, item, this.getCompatTable)
          }
          // check ram
          // ram type
          if(this.allMenuOptions && this.allMenuOptions.ram.item.contents && spc.toLowerCase().includes('ram type')){
            this.getCompatibility({item: item, withType: 'ram', option: 'ram_type'})
            specsArr[index].compatible = this.checkCompatTable('ram', 'ram_type', this.allMenuOptions, item, this.getCompatTable)
          }
          // check case
          // size
          if(this.allMenuOptions && this.allMenuOptions.case.item.contents && spc.toLowerCase().includes('size')){
            this.getCompatibility({item: item, withType: 'case', option: 'form_factor'})
            specsArr[index].compatible = this.checkCompatTable('case', 'form_factor', this.allMenuOptions, item, this.getCompatTable)
          }
        }
//PSU
        // Size
        if(item.type == 'psu' && spc.toLowerCase().includes('size')){
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            this.getCompatibility({item: item, withType: 'motherboard', option: 'form_factor'})
            specsArr[index].compatible = this.checkCompatTable('motherboard', 'form_factor', this.allMenuOptions, item, this.getCompatTable)
          }
          // check case
          if(this.allMenuOptions && this.allMenuOptions.case.item.contents){
            this.getCompatibility({item: item, withType: 'case', option: 'form_factor'})
            specsArr[index].compatible = this.checkCompatTable('case', 'form_factor', this.allMenuOptions, item, this.getCompatTable)
          }
        }
        // check general
        if(item.type == 'psu' && spc.toLowerCase().includes('wattage')){
          if(this.allMenuOptions){
            this.getCompatibility({item: item, withType: 'general', option: 'power'})
            specsArr[index].compatible = this.checkCompatTable('general', 'power', this.allMenuOptions, item, this.getCompatTable)
          }
        }
      })
      // console.log(specsArr)
      return specsArr
    },
    async deletePartLocal(part){
      this.model = part.model
      await this.deletePart({type: part.type, id: part.id})
      this.fetchItems(part.type)
    },
    unset(item) {
      if (item !== null) {
        item.contents = null;
        this.rmFromBuild({item: item, id: undefined});
        this.rmFromMenu({item: item, id: undefined});
      }
    },
    updatePart(item){
      this.setItem(item)
      this.$router.push('editpart?type='+item.type).catch(()=>{})
    },
    enlarge(item) {
      EventBus.$emit("enlarge", item);
    },
    getType(){
      this.type = this.$route.path.replace(/\\|\/builder\//g,'') 
      return this.type
    },
    checkIfInCompareList(item) {
      var result = false
      var compare_list = {...this.getCompareList}
      if(compare_list[this.getType()]){
        compare_list[this.getType()].map((itm) => {
          if(itm.id == item.id){
            result =  true
          }
        })
      }  
      return result  
    },
    buildItemId(tp){
      var type = tp
      if(type == 'ram'){
        return 2
      }
      if(type == 'storage'){
        return 3
      }
      if(type == 'gpu' || type == 'graphics'){
        return 4
      }
    },
    countStorage(build, type, id){
          var storageType = type
          var occupiedSata = 0
          var occupiedM2 = 0
          var storage = build[3].contents
          var sortedStorage = {}
          // Counting occupied ports
          if(storage && storage.length > 0){
            storage.map((itm) => {
              if(!sortedStorage[itm.id]){
                sortedStorage[itm.id] = []
              }
              sortedStorage[itm.id].push(itm)
              var size = itm.compat.size
              // IF STORAGE IS SATA
              if(!size.toLowerCase().includes('m.2')){
                occupiedSata++
              }
              // IF STORAGE IS M.2
              if(size.toLowerCase().includes('m.2')){
                occupiedM2++
              }
            })
            if(storageType = 'count' && id){
              if(sortedStorage[id]){
                return sortedStorage[id].length
              }
              return 0
            }
            if(storageType.toLowerCase().includes('m.2')){
              return occupiedM2
            }
            else return occupiedSata
          }
          else {return 0}
    },
    countGpus(build, id){
      var gpus = build[4].contents
      var sortedGpus = {}
      if(gpus && gpus.length > 0){
         gpus.map((itm) => {
           if(!sortedGpus[itm.id]){
                sortedGpus[itm.id] = []
              }
              sortedGpus[itm.id].push(itm)
         })
        if(sortedGpus[id]){
          return sortedGpus[id].length
        }
        return 0
      }
      return 0
    },
    tooltips(tooltip) {
      if(this.ifTooltip[tooltip] == true){
        return true
      }
      else return false
    },
    hasEmptySlots(item, build, count){
      var type = item.type
      var slotsLeft = 99
      var mb
      // RAM
      if(type == 'ram'){
        var sticksTotal = 0
        var limit = 9
        var ram = build[2].contents
        mb = build[1].contents
        if(ram && ram.length > 0){
          ram.map((item) => {
            if(item.compat.number_of_items){
              var sticks = parseInt(item.compat.number_of_items)
              sticksTotal += sticks
            }
          })
        }
        if(mb && mb.compat.ram_slots){
          limit = parseInt(mb.compat.ram_slots)
        }
        if(count == true){
          slotsLeft = limit - sticksTotal
          return slotsLeft
        }
        if(sticksTotal >= limit){
            return false
        }
        else {
          return true
        }
      }
      // STORAGE
      if(type == 'storage'){
        var occupiedSata = 0
        var occupiedM2 = 0
        var maxSata =  9
        var maxM2 =  9
        mb = build[1].contents
        var storage = build[3].contents
        // Setting max ports
        if(mb && mb !==null){
          if(parseInt(mb.compat.M_2_Slot) >0){
            maxM2 = parseInt(mb.compat.M_2_Slot)
          }
          if(parseInt(mb.compat.sata_slots) >0){
            maxSata = parseInt(mb.compat.sata_slots)
          }
        }
        // Counting occupied ports
        if(storage && storage.length > 0){
          storage.map((existingItem) => {
            var size = existingItem.compat.size
            // IF STORAGE IS SATA
            if(!size.toLowerCase().includes('m.2')){
              occupiedSata++
            }
            // IF STORAGE IS M.2
            if(size.toLowerCase().includes('m.2')){
              occupiedM2++
            }
          })
        }
        // If no more free sata slots
        if(!item.compat.size.toLowerCase().includes('m.2')){
          if(count == true){
            slotsLeft = maxSata - occupiedSata
            return slotsLeft
          }
          if(occupiedSata >= maxSata){
            return false
          }
        }
        // If no more free m.2 slots
        if(item.compat.size.toLowerCase().includes('m.2')){
          if(count == true){
            slotsLeft = maxM2 - occupiedM2
            return slotsLeft
          }
          if(occupiedM2 >= maxM2){
            return false
          }
        }
        return true
      }
      //GPU
      if(type == 'gpu' || type == 'graphics'){
        var slotsTotal = 0
        var max =  9
        var gpu = build[4].contents
        mb = build[1].contents
        if(mb && mb.compat.pci_e_x16){
          max = parseInt(mb.compat.pci_e_x16)
        }
        if(gpu && gpu.length > 0){
          gpu.map(() => {
            slotsTotal += 1
          })
        }
        if(count == true){
          slotsLeft = max - slotsTotal
          return slotsLeft
        }
        if(slotsTotal >= max){
          return false
        }
        else {
          return true
        }
      }
      else {
        return true
      }
    },
    checkIfInBuild(item, build) {
      // console.log("CHECK IF IN BUILD", build)
      for (var i = 0; i < this.getBuild.length; i++) {
        if (
          this.getBuild[i].contents !== null &&
          item == this.getBuild[i].contents
        ) {
          console.log("IN BUILD ", item)
          return true;
          
        } else return false;
      }
    },
    async setChosen(item) {
      for (var i = 0; i < this.items.length; i++) {
        this.items[i].chosen = false;
      }
      item.chosen = true;
    },
  },
  computed:{
    ...mapGetters([
      "getTooltips",
      "getCompareList",
      "allMenuOptions",
      "getBuild",
      'getLayout',
      'getCurrentPartType',
      'getCompatLib',
      'getCompatTable',
      'allItemsLoaded',
      'getItems',
      'getMaxScores'
    ]),
    getWidth(){
      return window.innerWidth
    }
  },
  
  mounted() {
    EventBus.$on('extendList', () => {
			this.extend()
		})
    EventBus.$on('sortApplied', (items) => {
      console.log('SORT APPLIED ', items)
      this.setItems(items)
    });
    if (this.$route.name == 'Items'){
      this.setLayout('simple')
    }
  },
  updated() {
    this.setSearchFilters(this.getCurrentPartType)
  },
  created(){
    if(this.getCurrentPartType == 'cpu'){
      setTimeout(() => {this.loaded = true}, 100);
    }
    else {this.loaded = undefined}
  },
  beforeDestroy(){
    this.loaded = undefined
    this.itemsLoaded(false)

  }
};
</script>
<style scoped>
.bar1{
    position: relative;
    background-color: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.06);
    padding: 7px 10px;
    border-radius: 6px;
    backdrop-filter: blur(10px);
}
.bar1 div{
    position: relative;
    width: 0;
    height: 5px;
    border-radius: 3px;
    background-color: #00bc8c;
    border: 1px solid #03AC81;
    box-shadow: 0 0 5px rgba(35, 158, 87, 0.6);
}

#html-bar{
    animation: html-fill 1s forwards;
}
.icon-circle-with-cross {
  transition: 0.2s;
  border-color: #e64759 !important;
  color: #e64759 !important;
  background-color: transparent !important;
}
.gc-button {
  display:inline-block;
  text-align: center;
  font-size:  20px;
  height: 35px;
  width: 108px !important;
}
.small-bullet {
  color: #9198aa;
  font-size: 14px;
}
.incompatible {
  color: #e64759 !important;
  opacity: 0.65;
}
.compatible {
  color: #00bc8c;
}
.compatible .number span {
  color: #cfd2da;
}
.disabled  {
  opacity: 0.65 !important;
}
.tip {
  margin-top: 3px;
  text-align: center;
  padding: 0px 5px;
  width: -webkit-fill-available;
  /* border: 1px solid #3B3F4C;  */
  /* background-color: #25272F; */
  margin-right: 10px;
  border-radius: 6px;
  padding-bottom: 5px;
  padding-top: 5px;
  min-width: 105px;
  /* box-shadow: inset 0px 0px 2px #9198aa; */
  border: 1px solid #434857;
}
.list-title {
  color: #CFD2DA; 
}
.tip span {
  display: block;
  text-align: center;
}
.small-bullet.value {
  white-space: nowrap;
  color: #1997c6;
}
.icon-minus-hidden {
  display: none;
}
.icon-minus:hover {
  color: #e64759 !important;
}
.inCompareList {
  display: block !important;
}
.inCompareList-hide-add-btn {
  display: none;
}
.checked span {
  border-color: #1bc98e;  color: #cfd2da !important;
}
.price li{
  color: #e4d836 !important;
  margin-top: -3px;
}
.delete-form-partslist:hover {
  cursor: pointer;
  color: #e64759 !important;
}
.edit {
  cursor: pointer;
}
.tooltip {
  border: 1px solid #434857;
  background-color: #191b20;
  border-radius: 6px;
  text-align: center;

}
.message-box {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  display: inline-block;
  border: 1px solid white;
  height: 150px;
  width: 200px;
  text-align: center;
  padding-top: 3%;
  margin-left: 40%;
}
.view-options {
  margin: 0px;
  float: right;
}
.view-options span {
  color: #434857;
  text-transform: capitalize;
  font-size: 24px !important;
}
.view-options span.active {
  color: #1997c6;
}
.filters span.active {
  color: #1997c6;
}
.filters {
  height: 25px;
  padding: 0px 12px;
  margin: 0px;
  line-height: 25px;
  margin-left: 5px;
}
.filters span {
  vertical-align: middle;
  margin-right: 5px;
}
.filter-option {
  color: #9198aa;
}
.filter-option:hover {
  color: #1997c6;
  cursor: pointer;
}
.list-option:hover, .album-option:hover{
  cursor: pointer;
  color: #1997c6;
}
.demo .list-item-body {
  margin-bottom: 15px;
  padding: 8px 8px;
  padding-top: 10px;
  margin-left: 0px;
  transition: 0.2s;
}
.demo .list-item-body .item-ischosen {
   background-color: #243839 !important;
}
.demo .list-item-body:hover {
  border: 1px solid #9198aa !important;
}
.demo .img-list {
  height: 112px;
  width: 110px;
  min-width: 110px;
}
.title {
  color: #cfd2da !; 
}
.title:hover {
  color: #1997c6 !important;
  cursor: pointer;
}
li.item.title {
  font-size: 22px;
  margin-top: -3px;
}
.album .list-item-body {
  padding: 10px 0px !important;
  display: inline-block;
  width: 230px !important;
  min-height: 210px;
  vertical-align: top;
}
.margin-left{
  margin-left: 20px !important;
}
.album .img-list {
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin-bottom: 5px;
}
.album .list-item-body li {
  margin:0px;
  text-align: center;
}
.album .info-list {
  text-align: center;
  margin-left: 0px;
  position: relative;
  width: unset;
}
.item-desc {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  margin-top: 1px;
  max-width: 39vw;
  padding-left: 1px;
}
.list-icon {
  cursor: pointer;
}
.album .list-icon {
  border-radius: 6px;
  float: none;
  position: relative;
  padding: 0px;
  text-align: center;
  border: 1px solid #1A8CB7;
  color: #1A8CB7;
  width: 42%;
  display: inline-block;
  transition: 0.1s;
}
.album .list-icon:hover {
  color: white;
  background-color: #1A8CB7;
}
.album .list-icon:hover .check-btn {
  margin-top: 15px;
}
.album .check-btn {
  margin-left: 95px !important;
}
.demo:hover .benckmark.progress {
  background-color: #434857 !important;
}
.album .buttons-section {
  display: inline-block;
  width: 100%;
  text-align: center;
  margin-top: 8px;
}
.album .add-to-build-btn{
  margin-left: 12px;
  margin-right: 5px;
}
.album .delete-from-build-btn{
  display: none;
  margin-left: 12px;
  margin-right: 5px;
}
.album .add-to-compare-btn{
  margin-left: 5px;
}
.album .delete-from-compare-btn{
  margin-left: 5px;
  display: none;
}
.album .add-to-compare-btn.inCompareList-hide{
  display: none;
}
.album .delete-from-compare-btn.active{
  display: inline-block !important;
}
.album .delete-from-build-btn.active{
  display: inline-block !important;
}
.album .list-item-body:hover .delete-from-build-btn.inBuild{
   display: inline-block;
}
.full-height {
  height: unset !important;
}
.album .delete-from-build-btn span:hover{
   color: #e64759;
}
.tips-mob {
    display: none;
}
.tips {
  display: flex;
}
  @keyframes html-fill{
    100%{
        width: 90%;
    }
}
#css-bar{
    animation: css-fill 1s forwards;
}
@keyframes css-fill{
    100%{
        width: 75%;
    }
}
#js-bar{
    animation: js-fill 1s forwards;
}
@keyframes js-fill {
    100%{
        width: 82%;
    }
}
#jQuery-bar{
    animation: jQuery-fill 1s forwards;
}
@keyframes jQuery-fill{
    100%{
        width: 68%;
    }
}
@media screen and (max-width: 1000px){
  .smaller-btn {
    margin-top: 3px !important;
  }
  .gc-button {
    width: 94px !important;
  }
  
.tip {
    margin-right: 8px;
    padding-left: 8px;
    padding-top: 3px;
    padding-bottom: 3px;
    min-width: 96px;
  }
}
@media screen and (max-width: 863px){
  .tips {
    display: none;
  }
    .demo .list-item-body {
    padding-right: 8px !important;
  }
}
</style>